import { render, staticRenderFns } from "./NgChangePasswd.vue?vue&type=template&id=a343f4b4"
import script from "./NgChangePasswd.vue?vue&type=script&lang=js"
export * from "./NgChangePasswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports